"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Highcharts = __importStar(require("highcharts"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const accessibility_1 = __importDefault(require("highcharts/modules/accessibility"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledContainer = styled_components_1.default.div `
  .highcharts-series-1 {
    stroke-dasharray: 1, 8;
    stroke-linecap: round;
    stroke-miterlimit: 16;
  }
`;
accessibility_1.default(Highcharts);
const formatAmount = (amount) => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });
    return formatter.format(Number(amount));
};
let crosshairLine, crosshairPointerCircle, 
//crosshairAgeCircle,
crosshairPointerCircle1, 
//crosshairAgeLabel,
alertIcon = null, startAgeLabel = null, endAgeLabel = null, retirementAgeLine = null, retirementAgeLabel = null;
class SavingsBalanceChart extends React.Component {
    constructor(props) {
        super(props);
        this.chartRender = ({ target: c }) => {
            const { participantAge, runOutAge, hoveredAge, retirementAge } = this.props.data;
            const startAge = participantAge.length && participantAge[0];
            const endAge = participantAge.length && participantAge[participantAge.length - 1];
            const chartRenderer = c.renderer;
            const chartLeft = c.plotLeft;
            const chartTop = c.plotTop;
            const chartHeight = c.plotHeight;
            const s = c.series[0];
            const startAgePosition = s.points[0] ? s.points[0].clientX : null;
            const hoveredAgePosition = s.points[hoveredAge - startAge]
                ? s.points[hoveredAge - startAge].clientX
                : null;
            const endAgePosition = s.points[participantAge.length - 1]
                ? s.points[participantAge.length - 1].clientX
                : null;
            const alertAgePosition = runOutAge === null
                ? null
                : s.points[runOutAge - startAge]
                    ? s.points[runOutAge - startAge].clientX
                    : null;
            const retirementAgePosition = retirementAge === null
                ? null
                : s.points[retirementAge - startAge]
                    ? s.points[retirementAge - startAge].plotX
                    : null;
            const retirementAgeYPosition = retirementAge === null
                ? null
                : s.points[retirementAge - startAge]
                    ? s.points[retirementAge - startAge].plotY
                    : null;
            if (startAgeLabel) {
                startAgeLabel.destroy();
            }
            if (endAgeLabel) {
                endAgeLabel.destroy();
            }
            // alertIcon?.destroy?.();
            if (crosshairLine && crosshairLine.d) {
                crosshairLine.destroy();
                crosshairPointerCircle.destroy();
                crosshairPointerCircle1.destroy();
                // crosshairAgeCircle.destroy();
                // crosshairAgeLabel.destroy();
            }
            if (retirementAgeLabel) {
                retirementAgeLabel.destroy();
            }
            if (retirementAgeLine) {
                retirementAgeLine.destroy();
            }
            if (startAgePosition) {
                startAgeLabel = chartRenderer
                    .label(startAge, chartLeft + startAgePosition - 10, chartHeight + chartTop + 8)
                    .attr({
                    zIndex: 6
                })
                    .css({
                    color: '#3b4b59',
                    "font-size": "14px",
                    "font-family": "Nimbus Sans Regular"
                })
                    .add();
            }
            if (endAgePosition) {
                endAgeLabel = chartRenderer
                    .label(endAge, chartLeft + endAgePosition - 10, chartHeight + chartTop + 8)
                    .attr({
                    zIndex: 6
                })
                    .css({
                    color: '#3b4b59',
                    "font-size": "14px",
                    "font-family": "Nimbus Sans Regular"
                })
                    .add();
            }
            if (alertAgePosition) {
                alertIcon = chartRenderer
                    .image(`data:image/svg+xml;base64,${tokens.AssetIconAlert}`, chartLeft + alertAgePosition - 12, chartHeight + chartTop + 5, 24, 24)
                    .add();
            }
            if (retirementAgePosition &&
                retirementAge >= startAge &&
                retirementAge <= endAge) {
                retirementAgeLabel = chartRenderer
                    .label(retirementAge, chartLeft + retirementAgePosition - 10, chartHeight + chartTop + 8)
                    .css({
                    color: '#3b4b59',
                    fontSize: "14px",
                    opacity: endAgePosition - retirementAgePosition > 16 &&
                        retirementAgePosition - startAgePosition > 16
                        ? 1
                        : 0
                })
                    .attr({
                    zIndex: 6,
                    "stroke-width": 2
                })
                    .add();
                retirementAgeLine = chartRenderer
                    .path([
                    "M",
                    chartLeft + retirementAgePosition,
                    chartTop + retirementAgeYPosition,
                    "L",
                    chartLeft + retirementAgePosition,
                    chartHeight + chartTop
                ])
                    .attr({
                    "stroke-width": 2,
                    stroke: tokens.ColorGrey600,
                    zIndex: 6
                })
                    .add();
            }
            if (hoveredAgePosition) {
                const chartHeightPosition = chartTop;
                crosshairLine = chartRenderer
                    .path([
                    "M",
                    chartLeft + hoveredAgePosition,
                    chartHeightPosition,
                    "L",
                    chartLeft + hoveredAgePosition,
                    chartHeightPosition + chartHeight + 50
                ])
                    .attr({
                    "stroke-width": 2,
                    stroke: tokens.ColorBrandInteractiveBlue,
                    zIndex: 6
                })
                    .add();
                crosshairPointerCircle = chartRenderer
                    .circle(chartLeft + hoveredAgePosition, chartHeightPosition, 4)
                    .attr({
                    fill: "#FFFFFF",
                    stroke: tokens.ColorBrandInteractiveBlue,
                    "stroke-width": 2,
                    zIndex: 6,
                    opacity: 0
                })
                    .add();
                crosshairPointerCircle1 = chartRenderer
                    .circle(chartLeft + hoveredAgePosition, chartHeightPosition, 4)
                    .attr({
                    fill: "#FFFFFF",
                    stroke: tokens.ColorBrandInteractiveBlue,
                    "stroke-width": 2,
                    zIndex: 6,
                    opacity: 0
                })
                    .add();
                // crosshairAgeCircle = chartRenderer
                //   .circle(chartLeft + hoveredAgePosition, chartHeightPosition + 20, 12)
                //   .attr({
                //     fill: "white",
                //     stroke: tokens.ColorBrandInteractiveBlue,
                //     "stroke-width": 2,
                //     zIndex: 21
                //   })
                //   .add();
                // crosshairAgeLabel = chartRenderer
                //   .label(
                //     hoveredAge,
                //     chartLeft + hoveredAgePosition - 11,
                //     chartHeightPosition + 10
                //   )
                //   .css({
                //     color: tokens.ColorBrandInteractiveBlue,
                //     "font-size": "12px",
                //     "font-family": "Nimbus Sans Bold"
                //   })
                //   .attr({
                //     zIndex: 21,
                //     "stroke-width": 2
                //   })
                //   .add();
            }
        };
        this.tooltipFormatter = a => {
            const { participantAge } = this.props.data;
            const startAge = participantAge[0];
            const chartRenderer = a.chart.renderer, chartLeft = a.chart.plotLeft, chartTop = a.chart.plotTop, chartHeight = a.chart.plotHeight;
            if (crosshairLine && crosshairLine.d) {
                crosshairLine.destroy();
                crosshairPointerCircle.destroy();
                crosshairPointerCircle1.destroy();
                // crosshairAgeCircle.destroy();
                // crosshairAgeLabel.destroy();
            }
            const { plotX: hx1, plotY: hy1, x: age } = a.chart.hoverPoint;
            const points = a.chart.hoverPoints;
            const { plotX: x0, plotY: y0 } = points[0];
            let x1 = 0, y1 = 0;
            if (points[1]) {
                const { plotX, plotY } = points[1];
                x1 = plotX;
                y1 = plotY;
            }
            crosshairLine = chartRenderer
                .path([
                "M",
                chartLeft + hx1,
                chartTop + (y1 > 0 ? Math.min(hy1, y0, y1) : Math.max(hy1, y0, y1)),
                "L",
                chartLeft + x0,
                chartTop + chartHeight + 20
            ])
                .attr({
                "stroke-width": 2,
                stroke: tokens.ColorBrandInteractiveBlue,
                zIndex: 6
            })
                .add();
            crosshairPointerCircle = chartRenderer
                .circle(chartLeft + hx1, chartTop + (y1 > 0 ? Math.min(hy1, y0, y1) : Math.max(hy1, y0, y1)), 4)
                .attr({
                fill: "#FFFFFF",
                stroke: tokens.ColorBrandInteractiveBlue,
                "stroke-width": 2,
                zIndex: 6
            })
                .add();
            crosshairPointerCircle1 = chartRenderer
                .circle(chartLeft + hx1, chartTop + Math.max(hy1, y0, y1), 4)
                .attr({
                fill: "#FFFFFF",
                stroke: tokens.ColorBrandInteractiveBlue,
                "stroke-width": 2,
                zIndex: 6
            })
                .add();
            // crosshairAgeCircle = chartRenderer
            //   .circle(chartLeft + hx1, chartTop + chartHeight + 20, 12)
            //   .attr({
            //     fill: "white",
            //     stroke: tokens.ColorBrandInteractiveBlue,
            //     "stroke-width": 2,
            //     zIndex: 6
            //   })
            //   .add();
            // crosshairAgeLabel = chartRenderer
            //   .label(startAge + age, chartLeft + hx1 - 11, chartTop + chartHeight + 9)
            //   .css({
            //     color: tokens.ColorBrandInteractiveBlue,
            //     "font-size": "12px",
            //     "font-family": "Nimbus Sans Bold"
            //   })
            //   .attr({
            //     zIndex: 6,
            //     "stroke-width": 2
            //   })
            //   .add();
            const balanceGap = points[1] && points[1].y ? points[0].y - points[1].y : 0;
            let tooltipHTML = "";
            tooltipHTML = points.reduce(function (s, point) {
                const legendSymbol = point.series;
                return (s +
                    `<div style="display: flex; justify-content: space-between;">
              <div style="display: flex; align-items: center; font-family: Nimbus Sans Bold">
                <svg width='20' height='20' class=${point.series.name === "Target Savings"
                        ? "highcharts-series-1"
                        : ""}>
                ${(legendSymbol && legendSymbol.legendGroup) && legendSymbol.legendGroup.element.firstChild.outerHTML}
                </svg>
                ${point.series.name}
              </div>
              <div>${formatAmount(point.y)}</div>
          </div>`);
            }, "");
            if (points[1]) {
                tooltipHTML =
                    `<div style="display: flex;flex-direction: column;width: 290px; font-family: Nimbus Sans Bold;padding: 16px;z-index: 9999 !important; opacity: 1;background-color: white;">` +
                        tooltipHTML +
                        `<div style="display: flex; justify-content: space-between; margin-top: 16px; font-family: Nimbus Sans Bold">
            <div>Balance Gap</div>
            <div style="color:${balanceGap >= 0
                            ? tokens.ColorFunctionalGreen500
                            : tokens.ColorFunctionalRed500}">${formatAmount(Math.abs(balanceGap))}</div>
        </div>
        <div style="font-family: Nimbus Sans Regular;font-size: 11px; margin-top: 24px; margin-bottom: -36px; color: ${tokens.ColorGrey600}">
        </div>
        </div>`;
            }
            return tooltipHTML;
        };
        this.state = {
            options: {
                chart: {
                    events: {
                        render: this.chartRender
                    }
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth < 768) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                chart: {
                                    width: 343,
                                    height: 185
                                },
                                tooltip: {
                                    enabled: false
                                },
                                legend: {
                                    enabled: false
                                }
                            }
                        },
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth >= 768) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                tooltip: {
                                    enabled: false
                                },
                                legend: {
                                    enabled: false
                                }
                            }
                        },
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth > 768 && window.innerWidth <= 1024) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                chart: {
                                    width: 432,
                                    height: 274
                                },
                                tooltip: {
                                    enabled: false
                                },
                                legend: {
                                    enabled: false
                                }
                            }
                        },
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth > 1024) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                tooltip: {
                                    enabled: true,
                                    distance: 16,
                                    borderColor: "none",
                                    backgroundColor: "white",
                                    shared: true,
                                    useHTML: true,
                                    formatter: this.tooltipFormatter
                                },
                                legend: {
                                    enabled: false,
                                }
                            }
                        }
                    ]
                },
                title: {
                    text: ""
                },
                xAxis: {
                    tickInterval: 1,
                    tickColor: "transparent",
                    tickLength: 30,
                    lineColor: tokens.ColorGrey600,
                    lineWidth: 2,
                    labels: {
                        enabled: false
                    },
                    title: {
                        align: 'low',
                        text: 'Age',
                        y: 4,
                        x: -40,
                        style: {
                            fontFamily: 'Nimbus Sans Regular',
                            fontSize: '14px',
                            color: '#3b4b59'
                        }
                    }
                },
                yAxis: {
                    minorGridLineWidth: 0,
                    minorTickInterval: 10000000000,
                    minorTickColor: '#000000',
                    minorTickWidth: 2,
                    minorTickLength: 50,
                    title: {
                        text: ""
                    },
                    showFirstLabel: false,
                    gridLineColor: ""
                },
                plotOptions: {
                    line: {
                        label: {
                            enabled: false
                        },
                        events: {
                            mouseOut: () => {
                                if (crosshairLine && crosshairLine.d) {
                                    crosshairLine.destroy();
                                    crosshairPointerCircle.destroy();
                                    crosshairPointerCircle1.destroy();
                                    // crosshairAgeCircle.destroy();
                                    // crosshairAgeLabel.destroy();
                                }
                            }
                        },
                        lineWidth: 4,
                        marker: {
                            enabled: false
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        },
                        enableMouseTracking: false
                    }
                },
                series: [...props.data.series],
                credits: {
                    enabled: false
                }
            }
        };
    }
    static getDerivedStateFromProps(props, state) {
        return Object.assign(Object.assign({}, state), { options: Object.assign(Object.assign({}, state.options), { series: [...props.data.series] }) });
    }
    render() {
        const { options } = this.state;
        const { data } = this.props;
        if (!data) {
            return null;
        }
        const { simulationType, participantAge } = this.props.data;
        if (!simulationType || !participantAge || participantAge.length === 0) {
            return null;
        }
        return (React.createElement(StyledContainer, null,
            React.createElement(highcharts_react_official_1.default, { highcharts: Highcharts, options: options })));
    }
}
exports.default = SavingsBalanceChart;
//# sourceMappingURL=SavingsBalanceChart.js.map